module.exports = "/_next/static/images/39-1-01d4ad29f0d84672b8689abaf54f1823.jpg";